import * as React from 'react';
import { useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import 'react-toastify/dist/ReactToastify.css';


export default function FormalLogin(props) {
    const { formalLoginValues, handleFormalLoginValue, handleFormalLoginSubmit, handleShowingFormsValues, disableButton } = props
    const [phoneEnable, setPhoneEnable] = useState(false)
    const [useMobileNumber, setUseMobileNumber] = useState(false)
    const gmailClick = () => {
        handleShowingFormsValues("GmailPopUp")
    }

    return (
        <Box
            sx={{
                marginTop: 0.5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Avatar sx={{ m: 0.5, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5" >
                ورود به برنامه
            </Typography>
            <Box noValidate sx={{ mt: 1 }}>
                {useMobileNumber ? (<PhoneInput
                    placeholder="شماره تلفن"
                    countryCodeEditable={false}
                    inputStyle={{ color: 'black', width: "220px", textDecoration: phoneEnable ? "" : "line-through" }}
                    containerStyle={{ color: 'black', direction: "ltr" }}
                    buttonStyle={{}}
                    //   dropdownStyle={{height:'50px'}}
                    country={'ir'}
                    enableSearch={true}
                    onChange={phone => { setPhoneEnable(true); handleFormalLoginValue("loginInfo", phone) }}
                />) : (<TextField
                    //   margin="normal"
                    sx={{ mt: 1.2, textDecoration: phoneEnable ? "line-through" : "" }}
                    required
                    fullWidth
                    id="loginInfo"
                    size="small"
                    // value={loginValue}
                    label="نام کاربری یا ایمیل"
                    name="loginInfo"
                    autoComplete="loginInfo"
                    onChange={(e) => { setPhoneEnable(false); handleFormalLoginValue("loginInfo", e.target.value) }}
                />)}

                <Box>
                    <TextField
                        //   margin="normal"
                        sx={{ m: 0.3, mt: 1.5 }}
                        required
                        fullWidth
                        name="password"
                        value={formalLoginValues.password}
                        label="کلمه عبور"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        onChange={(e) => handleFormalLoginValue("password", e.target.value)}
                    />
                </Box>

                <Button
                    disabled={disableButton}
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 1, mb: 1 }}
                    onClick={handleFormalLoginSubmit}
                >
                    ورود
                </Button>
                <hr />
                <Button color="secondary" variant="contained" sx={{ m: "auto", p: 1, mb: .5, border: "1px dashed" }} onClick={() => { handleShowingFormsValues("RegisterStep1") }}>
                    ثبت نام نکرده اید؟ ثبت نام کنید
                </Button>
                <Link href="#" onClick={() => { setUseMobileNumber(!useMobileNumber) }} variant="body2">
                    {useMobileNumber ? "لاگین با نام کاربری و کلمه عبور" : "لاگین با شماره تلفن و کلمه عبور"}
                </Link>
                <br />
                <Link href="#" onClick={gmailClick} variant="body2">
                    لاگین با Gmail
                </Link>
                <br />
                <Link href="#" onClick={() => { handleShowingFormsValues("ForgetPassword") }} variant="body2">
                    فراموشی کلمه عبور
                </Link>
                <hr />

            </Box>
        </Box>
    );
}